import React, { useContext, useEffect, useState } from "react";
import "./WipDynamicPage.css";
import ClientLeftSection from "components/ui/ClientFlow/clientLeftAndRightSection/ClientLeftSection";
import { useParams } from "react-router-dom";
import ClientRightSection from "components/ui/ClientFlow/clientLeftAndRightSection/ClientRightSection";
import { Divider } from "@mui/material";
import { useClientContext } from "context/ClientContext";
import { useGlobalContext } from "context/GlobalContext";
import SortContext from "context/SortContext";
import { useWipDepartment, useWipDepartmentDesign } from "./Api";

const WipDynamicPage = () => {
  const { categories, clientId } = useParams();
  const [selectedLeftCard, setSelectedLeftCard] = useState(null);

  const { setShowBagIcon, setBagCount, setDiaWeight, setGoldWeight } = useClientContext();
  const { setSearch } = useContext(SortContext);
  const { setSearchPlaceHolder } = useGlobalContext();

 // Wip Department 

  const params = {
    departmentGroupName: categories,
    sortBy: "",
    sortOrder: "asc",
    searchBy: "",
    clientCode: clientId,
  };


  const { data: wip, isLoading, isError } = useWipDepartment(params);


  const wipData = {
    items: wip?.departmentCode,
  };

  const getData = () => {
    switch (categories) {
      case "Pending":
        return wipData;
      case "Pre-Production":
        return wipData;
      case "Production":
        return wipData;
      case "Post-Production":
        return wipData;
      case "Other":
        return wipData;
      default:
        return [];
    }
  };

  const getHeader = () => {
    switch (categories) {
      case "Pending":
        return `Department - ${wip?.departmentCode?.length || 0}`;
      case "Pre-Production":
        return `Department - ${wip?.departmentCode?.length || 0}`;
      case "Production":
        return `Department - ${wip?.departmentCode?.length || 0}`;
      case "Post-Production":
        return `Department - ${wip?.departmentCode?.length || 0}`;
      case "Other":
        return `Department - ${wip?.departmentCode?.length || 0}`;
      default:
        return "Details";
    }
  };

  const getType = () => {
    switch (categories) {
      case "Pending-quotes":
        return "wip";
      case "Pre-Production":
        return "wip";
      case "Production":
        return "wip";
      case "Post-production":
        return "wip";
      case "Other":
        return "wip";
      default:
        return "wip";
    }
  };

  const data = getData();

  useEffect(() => {
    setSearch(true);
    setSearchPlaceHolder("Search Transaction number");
    if (data?.items?.length > 0) {
      const defaultCard = data.items[0];
      setSelectedLeftCard(defaultCard);
    }
    setShowBagIcon(true);

    return () => {
      setShowBagIcon(false);
      setSearchPlaceHolder("");
      setSearch(false);
      setSelectedLeftCard(null);
    };
  }, [categories]);

  useEffect(() => {
      setBagCount(wip?.totalDepartmentCode?.TotalBQty || 0);
      setDiaWeight(wip?.totalDepartmentCode?.TotalRequiredDWt || 0);
      setGoldWeight(wip?.totalDepartmentCode?.TotalRequiredNWt || 0);
  
      return () => {
        setBagCount(0);
        setDiaWeight(0);
        setGoldWeight(0);
      };
    }, [wip]);

  const selectedItem = data?.items?.find((item) => item?.DepartmentCode === selectedLeftCard?.DepartmentCode);


  // Wip Designs

  const params2 = {
    departmentCode: selectedItem?.DepartmentCode,
    sortBy: "",
    sortOrder: "asc",
    page: 1,
    limit: 50,
    searchBy: "",
    clientCode: clientId,
  };

  const { data: wipDesigns, isLoading: isLodingDesigns, isError: isErrorDesigns, isFetching } = useWipDepartmentDesign(params2);

  // console.log("wipDesigns=========>>>>>>",wipDesigns)

  const selectedRightData = selectedLeftCard
    ? {
        header: `${selectedItem?.DepartmentCode} - ${wipDesigns?.departmentCodeCardData?.length}`,
        items: wipDesigns?.departmentCodeCardData,
      }
    : {
        header: "Select a card",
        items: [],
      };

  return (
    <div className="wip-container">
      <Divider sx={{ height: "4px", background: "#0D0D0D", borderBottom: "none", marginLeft: "-22px" }} />
      <div className="content-wrapper">
        {/* Left Section - Transactions - Takes 1/3 */}
        <div className="client-left-section">
          <ClientLeftSection data={getData()} header={getHeader()} type={getType()} selectedCard={selectedLeftCard} setSelectedCard={setSelectedLeftCard} />
        </div>

        <Divider orientation={"vertical"} sx={{ width: "4px", background: "#0D0D0D", border: "none", marginTop: "-20px" }} />

        {/* Right Section - Items - Takes 2/3 */}
        <div className="client-right-section">
          <ClientRightSection data={selectedRightData} type={getType()} isLoading={isLodingDesigns} allData={wipDesigns?.departmentCodeCardData}/>
        </div>
      </div>
    </div>
  );
};

export default WipDynamicPage;
